import { FomLogo } from './Bausteine'

/** Usercentrics CMP v3 stellt window.__ucCmp bereit (Banner wird in index.html geladen). */
type UcCmp = { showSecondLayer?: () => void }
const cookieEinstellungen = () => (window as unknown as { __ucCmp?: UcCmp }).__ucCmp?.showSecondLayer?.()

export default function FomFooter() {
  return (
    <footer className="bg-konf-tief py-10 text-sm text-white/60">
      <div className="huelle flex flex-wrap items-center justify-between gap-5">
        <FomLogo className="h-10" />
        {/* PLATZHALTER: Verweise eintragen, sobald die Adressen feststehen. */}
        <nav aria-label="Rechtliches" className="flex gap-2">
          <a className="inline-flex min-h-[44px] items-center px-3 underline underline-offset-[3px] hover:text-white" href="#impressum">Impressum</a>
          <a id="datenschutz" className="inline-flex min-h-[44px] items-center px-3 underline underline-offset-[3px] hover:text-white" href="#datenschutz">Datenschutz</a>
          <button type="button" onClick={cookieEinstellungen} className="inline-flex min-h-[44px] items-center px-3 underline underline-offset-[3px] hover:text-white">
            Cookie-Einstellungen
          </button>
        </nav>
      </div>
    </footer>
  )
}
